import doLineSegmentsIntersect from './line_segments_intersect'

export function polygonCentroidOrBoundsCenter(polygon) {
  try {
    const path = polygon.getPath();
    const pts = path && typeof path.getArray === 'function' ? path.getArray() : [];
    if (pts.length < 3) return polygon.getBounds ? polygon.getBounds().getCenter() : pts[0] || null;

    // Centroid formula (treating lat/lng as planar; good enough for UX handle placement)
    let area = 0;
    let cx = 0;
    let cy = 0;
    for (let i = 0; i < pts.length; i++) {
      const p0 = pts[i];
      const p1 = pts[(i + 1) % pts.length];
      const x0 = p0.lng();
      const y0 = p0.lat();
      const x1 = p1.lng();
      const y1 = p1.lat();
      const a = x0 * y1 - x1 * y0;
      area += a;
      cx += (x0 + x1) * a;
      cy += (y0 + y1) * a;
    }
    area *= 0.5;
    if (area === 0) throw new Error('degenerate polygon');
    cx /= (6 * area);
    cy /= (6 * area);
    return new google.maps.LatLng(cy, cx);
  } catch (e) {
    if (polygon.getBounds && polygon.getBounds()) return polygon.getBounds().getCenter();
    return null;
  }
}

export function isSimplePolygonLatLng(latLngArray) {
  if (!latLngArray || latLngArray.length < 3) return false;
  const pointsArray = latLngArray.map((p) => ({ x: p.lng(), y: p.lat() }));

  for (let i = 0; i < (pointsArray.length - 1); i++) {
    const a = pointsArray[i];
    const b = pointsArray[i + 1];

    for (let j = i; j < (pointsArray.length - 2); j++) {
      const c = pointsArray[j + 2];
      let d;
      if (j + 3 < pointsArray.length) {
        d = pointsArray[j + 3];
      } else if (i !== 0) {
        d = pointsArray[0];
      } else {
        continue;
      }

      if (doLineSegmentsIntersect(a, b, c, d)) {
        return false;
      }
    }
  }
  return true;
}
